import {isNil} from 'ramda';

import {SourcingColorResponseBody} from '@dms/api/core';

import {Nullish} from 'shared/web';

/** German capitalizes nouns, so "Metallic" stays as it is in "Schwarz Metallic". */
const LANGUAGES_KEEPING_SPECIFICATION_CASE = ['de'];

/**
 * Body color with its type when known, e.g. "Černá metalíza" / "Schwarz Metallic";
 * only the color without a type, null without a color.
 */
export const formatBodyColor = (color: SourcingColorResponseBody | Nullish, language: string) => {
  const name = color?.color?.translation;

  if (isNil(name)) {
    return null;
  }

  const specification = color?.specification?.translation;

  if (isNil(specification) || specification.length === 0) {
    return name;
  }

  const formattedSpecification = LANGUAGES_KEEPING_SPECIFICATION_CASE.includes(language)
    ? specification
    : specification.charAt(0).toLocaleLowerCase(language) + specification.slice(1);

  return `${name} ${formattedSpecification}`;
};
